<template>
  <div class="arrears-list">
    <!-- <div v-if="$route.query.carNumber" @click="$router.go(-1)">返回></div> -->
    <div class="searchbox order_searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <label for>车牌号:</label>
          <input
            v-model="search.carNumber"
            class="form-control"
            type="text"
            size="12"
          />
        </div>
        <div class="form-group">
          <label for="bdate">入场时间:</label>
          <bosk-shortcut-date
            v-on:current-date-change="onCurrentDateChange"
            v-bind:currentDate="search.entryDate"
          ></bosk-shortcut-date>
          <!-- <el-date-picker
            clearable
            v-model="search.entryDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker> -->
        </div>
        <!-- <div class="form-group">
          <label for="bdate">离场时间:</label>
          <el-date-picker
            clearable
            value-format="yyyy-MM-dd HH:mm:SS"
            v-model="search.exitDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </div> -->
        <div class="form-group others">
          <span class="search_btn">
            <button
              @click="searchList"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              查询
            </button>
          </span>
          <span class="download_btn">
            <el-button
            v-if="buttonPermissions.btn_download"
             type="primary"
              size="small" 
              @click="downloadExcel"
              >导出</el-button
            >
          </span>
          <span
            class="batchDel_btn gap"
            :style="{ cursor: canBatchCancel ? 'not-allowed' : 'pointer' }"
          >
            <button
              v-if="buttonPermissions.btn_clear"
              type="button"
              :class="['btn', 'btn-default', canBatchCancel ? 'is-gray' : '']"
              @click="executeBatchEliminate"
              :disabled="canBatchCancel"
            >
              批量冲销
            </button>
          </span>
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table
        v-loading="loading"
        ref="table"
        border
        :data="tableListData.rows"
        height="100%"
        width="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        @selection-change="onSelectionChange"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="停车道路" width="180px">
          <template slot-scope="scope" >{{
            !scope.row.parkingId
              ? ""
              : JSON.parse(scope.row.parkingId).parkingName
          }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="岗位名称" prop="areaName">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150px"
          label="订单号"
          prop="orderNum"
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip width="150px" label="车牌号">
          <template slot-scope="scope">{{
            !scope.row.plaId ? "" : JSON.parse(scope.row.plaId).carNumber
          }}</template>
        </el-table-column>
        <el-table-column
          width="150px"
          label="入场时间"
          prop="beginDate"
        ></el-table-column>
        <el-table-column
          width="150px"
          label="离场时间"
          prop="endDate"
        ></el-table-column>

        <el-table-column
          width="150px"
          label="停车时长"
          prop="parkingLongTime"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          label="手机号"
          prop="phone"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="金额"
          prop="shouldMoney"
        ></el-table-column>

        <!-- <el-table-column
          show-overflow-tooltip
          label="ETC"
          prop="attr1"
        ></el-table-column> -->
        <el-table-column show-overflow-tooltip label="操作" width="250px">
          <template slot-scope="scope">
            <!-- <button
              type="button"
              v-bind:class="[
                scope.row.attr1 === '是' ? 'is-gray' : '',
                'operate-button',
              ]"
              :disabled="scope.row.attr1 === '是'"
              @click="onVerityEtcBtn(scope.row)"
            >
              认证
            </button> -->
            <button
              type="button"
              @click="showPhoto(scope.row.platenumImage)"
              class="photo"
            >
              查看图片
            </button>
            <!-- <button
              type="button"
              v-bind:class="[
                scope.row.attr1 !== '是' ? 'is-gray' : '',
                'operate-button',
              ]"
              :disabled="scope.row.attr1 !== '是'"
              @click="onEtcPayBtn(scope.row)"
            >
              追缴
            </button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--查看图片-->
    <div ref="imgDialog" class="imgDialog">
      <el-dialog
        ref="show"
        height="80%"
        :visible.sync="photoDialogVisible"
        :show-close="false"
        @closed="hiddenShade"
        @opened="showImg"
      >
        <div slot="footer">
          <span v-show="photoY" ref="spanImg" class="img-container">
            <img ref="img1" src width="50%" height="auto" />
            <img ref="img2" src width="50%" height="auto" />
          </span>
          <span class="photoN" v-show="photoN">暂无图片</span>
        </div>
      </el-dialog>
    </div>
    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";

import {
  getArrearsList,
  getOrderList,
  reqVerifyEtc,
  reqEtcPay,
  batchCancelOrders,
} from "@/api/url";

import Page from "@/page/commons/page";
import { MessageBox } from "element-ui";
import dayjs from "dayjs";
const isBetween = require("dayjs/plugin/isBetween");
dayjs.extend(isBetween);
export default {
  inject: ["searchParams"],
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },

      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      photoDialogVisible: false,
      photoY: false,
      photoN: false,
      photoShow: false,
      imgList: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        carNumber: "",
        entryDate: [],
        exitDate: [],
      },
      tableListData: {},
      pageObj: {},
      selectedList: [],
      totalMap: {},
      loading: false,
      buttonPermissions: {
        btn_clear: false,
        btn_download : false,
      },
    };
  },
  components: {
    Page,
  },
  computed: {
    ...mapGetters(["elements"]),
    canBatchCancel: function() {
      return (
        this.selectedList.length === 0 ||
        !this.selectedList.some(
          (s) =>
            s.orderStatus !== "已取消" &&
            s.orderStatus !== "已完成" &&
            s.orderStatus !== "取消申请中" &&
            s.orderStatus !== "删除申请中" &&
            s.orderStatus !== "异常结束"
        )
      );
    },
  },

  created: function() {
    // this.search.carNumber = this.$route.query.carNumber;
    // this.search.entryDate = this.$route.query?.crtTime?.split("~") ?? [];
  },
  mounted: function() {
    //首次从欠费统计点击进入或者直接点击欠费列表进入
    this.$nextTick(() => {
      const { carNumber, entryDate } = this.searchParams;

      this.search = { ...this.search, carNumber, entryDate:entryDate??[] };
      if(!carNumber) return;
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    });
  },

  activated() {
    //再次从欠费统计点击进入
    this.$nextTick(() => {
  
      const { carNumber, entryDate } = this.searchParams;
      if (
        !carNumber ||
        entryDate.length === 0 ||
        (carNumber === this.search.carNumber &&
          entryDate.join("") === this.search.entryDate.join(""))
      )
        return;
      this.search = { ...this.search, carNumber, entryDate:entryDate??[] };
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    });
  },
  watch: {
    elements: {
      handler: function(val, oldVal) {
     
        this.permiss();
      },
      deep: true, //深度
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("tabNavigation", ["delNavigation"]),
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    onSelectionChange(val) {
      this.selectedList = [...val];
    },
    executeBatchEliminate() {
      // const orders = this.selectedList.filter(
      //   ({ orderStatus }) =>
      //     orderStatus !== "已取消" &&
      //     orderStatus !== "已完成" &&
      //     orderStatus !== "取消申请中" &&
      //     orderStatus !== "删除申请中" &&
      //     orderStatus !== "异常结束"
      // );
      const orders = this.selectedList;
      const orderIds = orders.map(({ orderId }) => orderId);
      const ordrNums = orders.map(({ orderNum }) => orderNum);

      MessageBox.confirm(
        `此操作将冲销订单号为${ordrNums?.join(",") ?? ""}的订单, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          return this.$postRequest(batchCancelOrders(), [...orderIds]);
        })
        .then((data) => {
          if (data?.status == 200) {
            this.$message({
              type: "success",
              message: "批量冲销申请成功!",
            });
            this.tableList(this.pageObj.curIndex);
            this.selectedList = [];
          }
        })
        .catch((error) => {
          this.$message({
            type: "info",
            message: error,
          });
        });
    },
    tableList: function(curPage) {
      var _this = this;
      this.loading = true;
      const { carNumber, entryDate, exitDate } = this.search;
      let params = {
        limit: this.search.pageSize,
        page: curPage,
        orderStatus: "unpay",
      };
      if (carNumber) {
        params = { ...params, carNumber };
      }

      if (entryDate?.length > 0) {
        params = {
          ...params,
          crtTime:
            this.search.entryDate == ""
              ? ""
              : JSON.stringify(
                  this.search.entryDate.map((date) => this.formatDate(date))
                ),
          // beginDateStart: entryDate[0],
          // beginDateEnd: entryDate[1],
        };
      }
      // if (exitDate?.length > 0) {
      //   params = {
      //     ...params,
      //     endDateStart: exitDate[0],
      //     endDateEnd: exitDate[1],
      //   };
      // }
      this.$get(getOrderList(), {
        ...params,
      })
        .then((data) => {
          if (data.status != 200) return;
          //翻页
          var rows = data.data.rows;
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.pageObj = { ...pageObj };
          // _this.getPage(pageObj);
          _this.tableListData = {
            ...data?.data,
            rows: data?.data?.rows ?? {},
          };
          _this.totalMap = data?.data?.totalMap ?? {};
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchList: function() {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },

    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.type = "";
      this.search.startTime = "";
      this.search.endTime = "";
    },
    showPhoto(url) {
      this.photoDialogVisible = true;
      const urls = url?.split(",") ?? [];

      this.$refs.imgDialog.style.height = "100vh";
      this.$refs.imgDialog.style.width = "100vw";
      this.$refs.imgDialog.style.background = "rgba(0,0,0,0.5)";
      this.$refs.imgDialog.style.position = "fixed";
      this.$refs.imgDialog.style.top = 0 + "px";
      this.$refs.imgDialog.style.left = 0 + "px";
      this.$refs.imgDialog.style.zIndex = 9999;

      if (urls.length <= 0) {
        this.photoY = false;
        this.photoN = true;
      } else {
        this.photoY = true;
        this.photoN = false;

        this.$refs.img1.src = urls[0];
        this.$refs.img2.src = urls[1];
      }

      // this.imgDialog.url = url;
      this.$refs.show.open();
      // console.log(img)
      // ctx.drawImage(img,0,0);
      // window.open(url,'_blank');

      // this.imgViewerVisible = true;
      // this.imgList = url.split(",");
      // const m = (e) => {
      //   e.preventDefault();
      // };
      // document.body.style.overflow = "hidden";
      // document.addEventListener("touchmove", m, false); //禁止页面滑动
    },
    hiddenShade() {
      this.$refs.imgDialog.style.height = 0 + "px";
      this.$refs.imgDialog.style.width = 0 + "px";
    },
    showImg() {
      // console.log("6666")
    },
    onVerityEtcBtn(arrear) {
      const { pla_id } = arrear;

      this.$get(reqVerifyEtc(), { plaId: pla_id })
        .then((data) => {
          this.tableList(this.search.pageNumber);
          if (data.status === 200) {
            this.$message({
              type: "success",
              message: "验证成功",
            });

            return;
          }
          if (data.status !== 200) {
            this.$message({
              type: "warning",
              message: data.message,
            });
            return;
          }
        })
        .catch((err) => {
          this.$message({
            type: "warning",
            message: err,
          });
        });
    },
    onEtcPayBtn(arrear) {
      const { order_id } = arrear;
      this.$get(reqEtcPay(), { order_id })
        .then((data) => {
          if (data.status === 200) {
            this.$message({
              type: "success",
              message: "ETC扣款成功",
            });
            this.tableList(this.search.pageNumber);
            return;
          }
          if (data.status !== 200) {
            this.$message({
              type: "warning",
              message: data.message,
            });
            return;
          }
        })
        .catch((err) => {
          this.$message({
            type: "warning",
            message: err,
          });
        });
    },
    downloadExcel() {
      const { carNumber, entryDate, exitDate } = this.search;
      let params = { orderStatus: "unpay" };
      if (carNumber) {
        params = { ...params, carNumber };
      }
      if (entryDate?.length > 0) {
        params = {
          ...params,
          // crtTime:
          // this.search.entryDate == ""
          //   ? ""
          //   : JSON.stringify(
          //       this.search.entryDate.map((date) => this.formatDate(date))
          //     ),
          beginDateStart: entryDate?.[0] ? this.formatDate(entryDate[0]) : "",
          beginDateEnd: entryDate?.[1] ? this.formatDate(entryDate[1]) : "",
        };
      }
      // if (exitDate?.length > 0) {
      //   params = {
      //     ...params,
      //     endDateStart: exitDate[0],
      //     endDateEnd: exitDate[1],
      //   };
      // }
      this.$downloadFileRequest(
        `/api/parking/parkingOrders/unpayOrderExport?${this.jsonToUrlParams(
          params
        )}`,
        null,
        "欠费列表"
      );
    },
    jsonToUrlParams(json) {
      var paramsArray = [];
      for (var key in json) {
        if (json.hasOwnProperty(key)) {
          var value = json[key];
          var pair = encodeURIComponent(key) + "=" + encodeURIComponent(value);
          paramsArray.push(pair);
        }
      }
      return paramsArray.join("&");
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "总计";
        }

        if (index === 9) {
          sums[index] = this.totalMap?.arrearsMoneyTotal ?? 0;
        }
      });
      return sums;
    },
    formatDate(date) {
      return dayjs(date).format("YYYY-MM-DD");
    },
    onCurrentDateChange(v) {
   
      this.search.entryDate = [...v];
    },
    permiss() {
      this.buttonPermissions.btn_clear = this.elements["arrearslist:btn_clear"];
      this.buttonPermissions.btn_download = this.elements["arrearslist:btn_download"];
    },
  },
};
</script>
<style scoped>
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.searchbox {
  background: #f9f9fb;
  /* height:130px;
          line-height:45px; */
  border-bottom: 10px solid #eff2f7;
  /* height:150px; */
  padding: 10px 10px 0 10px;
}

.refresh {
  display: inline-block;
}

.bread_container {
  display: inline-block !important;
  border: none !important;
  padding: 0 !important;
}

/* .photo{
          width:60px;
          font-size:12px;
          background:#409EFF;
          color:white;
          height:20px;
          line-height:20px;
          
      } */
.imgDialog {
  overflow: hidden;
}
button.photo {
  height: 22px;
  line-height: 22px;
  color: #278cd8;
  background: none;
  font-size: 12px;
  margin-right: 5px;
}

.photoN {
  width: 350px;
  line-height: 300px;
  height: 300px;
  text-align: center;
  display: inline-block;
}

.imgDialog {
  animation: opacity2 3s;
  -webkit-animation: opacity2 3s;
  -moz-animation: opacity2 3s;
}

@keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

button.gray {
  color: gray;
}
.form-group {
  margin-bottom: 10px;
}
.gap {
  margin-right: 5px;
}
.arrears-list .list-right {
  height: calc(100vh - 270px)!important;
  padding-bottom: 0;
}
</style>
<style>
.arrears-list .el-date-editor {
  width: auto;
}
.arrears-list .el-date-editor.el-input__inner {
  max-width: none;
}
.arrears-list .el-date-editor .el-range-input {
  font-size: 12px !important;
}

.arrears-list .el-date-editor .el-range-separator {
  font-size: 12px !important;
}

.arrears-list .imgDialog .el-dialog__header {
  display: none;
  padding: 0;
}

.arrears-list .imgDialog .el-dialog__body {
  padding: 0 !important;
}

.arrears-list .imgDialog .el-dialog__footer {
  padding: 0 !important;
}

.arrears-list .searchbox .el-select {
  width: 150px !important;
}

.arrears-list .order_searchbox .form-control {
  width: 150px;
}
.arrears-list .order_searchbox form {
  height: auto;
}

.arrears-list .el-dialog {
  margin-top: 10vh !important;
}

/* .el-dropdown-link {
       display: inline-block;;
      cursor: pointer;
      color:white;
      background:#278cd8;
      height:34px;
      border-radius: 5px;
      padding-left:5px;
      font-size: 12px;
      line-height:37px;
      width:90px;
    } */
.arrears-list .el-icon-arrow-down {
  font-size: 12px;
}

.arrears-list .dowload {
  padding-left: 10px;
  display: inline-block;
}

.arrears-list .img-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0 20px 20px;
}

.arrears-list img {
  overflow: hidden;
}

.arrears-list .img-container img {
  box-sizing: border-box;
  padding-right: 20px;
}

.arrears-list .searchbox .form-inline {
  overflow: auto;
}
.arrears-list .is-gray {
  color: #666;
  cursor: not-allowed;
}
</style>
<style>
.arrears-list .modify-plate .el-input__inner {
  height: 40px;
}
.arrears-list .modify-plate .el-select {
  width: 100%;
}


.arrears-list .el-table__footer-wrapper tbody td.el-table__cell {
  text-align: center;
  color: red;
}
.arrears-list .batchDel_btn .btn:hover,
.arrears-list .batchDel_btn .btn:focus {
  color: #278cd8;
  border: 1px solid #278cd8;
  background: white;
}

</style>
